import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import Paper from '@material-ui/core/Paper';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

import { currencyFormat } from "../../func/func";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 260,
      height: 230,
      margin: '10px 10px'
    },
    left: {
      background: '#444',
      "& h4": {
        color: '#eee',
        fontSize: 13
      },
      "& hr": {
        margin: '5px auto',
        background: '#fff'
      },
      "& div": {
        color: '#aaa',
      },
      "& p": {
        color: '#ccc',
        fontSize: 13,
        marginBottom: 15
      },
      "& span": {
        margin: '15px 3px 5px 0',
        background: 'lightbule',
        fontSize: 10,
        padding: '1px 3px',
      }
    },
    lefttext: {
      fontSize: 9
    },
    righttext: {
      fontSize: 12,
      paddingTop: 3
    },
    right: {
      background: '#ddd',
      padding: 8,
      "& p": {
        fontSize: 12,
        marginBottom: 15
      },
    },
    rightCont: {
      padding: 12,
      position: 'relative',
      "& h6": {
        lineHeight: 1,
        marginBottom: 10
      }
    },
    media: {
      height: 90,
      width: 90,
      margin: '20px auto 0',
      objectFit: 'contain'
    },
    text: {
      fontSize: 9,
      textAlign: 'left',
      marginTop: 10
    },
    PERFECT: {
      background: "#26FE26",
      height: 5,
      marginBottom: 4
    },
    RECOMMENDED: {
      background: "blue",
      height: 5,
      marginBottom: 4
    },
    ACCEPTABLE: {
      background: "orange",
      height: 5,
      marginBottom: 4
    },
  }),
);

export default function CompanyCard(props) {
  const { item, index } = props;
  const classes = useStyles();

  return (
    <>
      <Card className={classes.root} >
        <Grid container spacing={1}>
          <Grid item xs={6} className={classes.left}>
            <CardMedia
              className={classes.media}
              image={`/img/logo${index + 1}.png`}
              title=""
              component="img"
            />
            <CardContent>
              <Typography variant="h4" align="center">
                {item.company.nameOfCompany}
              </Typography>
              <Typography align="center" className={classes.lefttext} component="div">
                {item.company.city}
              </Typography>
              <Typography align="center" className={classes.lefttext} component="div">
                {item.company.phoneNumber}
              </Typography>
              <Divider component="hr" />
              {
                ["követés", "kapcsolat"].map((item, index) => <Paper key={`p${index}`} component="span">{item}</Paper>)
              }
            </CardContent>
          </Grid>
          <Grid item xs={6} className={classes.right}>
            <CardContent className={classes.rightCont}>
              <Typography align="center" variant="h6" color="textSecondary">
                {item.nameOfPosition}
              </Typography>
              <Divider component="hr" className={classes[item.requiredMatchLevel]} />
              <Typography align="center" className={classes.righttext} component="div">
                {item.city}
              </Typography>
              <Typography align="center" className={classes.righttext} component="div">
                {currencyFormat(item.salary)}
              </Typography>
              <Typography align="center" className={classes.text} component="div">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis tortor libero, placerat non mauris non, sodales placerat quam. Fusce aliquet augue nec ante.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </>
  );
}